/* LiberLive C2 — Scrollytelling. Vanilla, per-instance, root-scoped.
   Each [data-llc2-scrolly] runs independently; Theme-Editor aware; no listener leaks. */
(function () {
  'use strict';

  var smooth = function (v) { var t = v < 0 ? 0 : v > 1 ? 1 : v; return t * t * (3 - 2 * t); };
  var mix = function (a, b, amt) { return a + (b - a) * smooth(amt); };
  var clamp01 = function (v) { return v < 0 ? 0 : v > 1 ? 1 : v; };
  var pad2 = function (i) { return (i < 10 ? '0' : '') + i; };

  function headerOffset() {
    var cs = getComputedStyle(document.documentElement);
    var names = ['--sticky-header-height', '--header-height'];
    for (var i = 0; i < names.length; i++) {
      var px = parseFloat(cs.getPropertyValue(names[i]));
      if (px > 0) return px;
    }
    var cands = document.querySelectorAll('header, [role="banner"], [id*="header" i], [class*="header" i]');
    for (var j = 0; j < cands.length; j++) {
      var el = cands[j], p = getComputedStyle(el).position, r = el.getBoundingClientRect();
      if ((p === 'sticky' || p === 'fixed') && r.top <= 1 && r.height > 0 && r.height < window.innerHeight * 0.5) return r.height;
    }
    return 0;
  }

  function initScrolly(root) {
    if (!root || root.__llc2) return;
    // Static mode: no sticky pin, no scroll scrubbing — CSS renders everything. Bind nothing.
    if (root.classList.contains('is-static')) { root.__llc2 = { destroy: function () { root.__llc2 = null; }, jumpTo: function () {} }; return; }

    var story = root.querySelector('[data-llc2-story]');
    var sticky = root.querySelector('[data-llc2-sticky]');
    var world = root.querySelector('[data-llc2-world]');
    var views = root.querySelectorAll('.llc2-view');
    var chapters = root.querySelectorAll('[data-llc2-chapter]');
    var railFill = root.querySelector('[data-llc2-railfill]');
    var jumps = root.querySelectorAll('[data-llc2-jump]');
    var callouts = root.querySelectorAll('[data-llc2-callout]');
    var viewport = root.querySelector('.llc2-viewport');
    var counterNow = root.querySelector('[data-llc2-counter-now]');
    if (!story || !sticky || !world || chapters.length === 0) return;

    // Callouts are anchored to the PRODUCT (data-cx/cy = % of the 100vmin world/product).
    // Each frame we project each feature point through the live camera (translate+scale)
    // into viewport px, so the dot rides the product as it zooms/pans (accurate + smooth).
    var coData = [];
    for (var ci = 0; ci < callouts.length; ci++) {
      coData.push({ el: callouts[ci], cx: parseFloat(callouts[ci].getAttribute('data-cx')) || 50, cy: parseFloat(callouts[ci].getAttribute('data-cy')) || 50 });
    }
    function positionCallouts(scale, camX, camY) {
      if (!viewport || !coData.length) return;
      var W = viewport.clientWidth, H = viewport.clientHeight;
      if (!W || !H) return;
      var vmin = Math.min(window.innerWidth, window.innerHeight) / 100;
      var cs = getComputedStyle(root);
      var mobile = window.innerWidth <= 749;
      // Match the CSS world anchor: desktop left:--llc2-prod-x / top:50%; mobile left:50% / top:--llc2-prod-y-m
      var prodX = mobile ? 50 : (parseFloat(cs.getPropertyValue('--llc2-prod-x')) || 63);
      var cyFrac = mobile ? ((parseFloat(cs.getPropertyValue('--llc2-prod-y-m')) || 35) / 100) : 0.5;
      // keep callouts inside the visible viewport so a low one (e.g. Volume) is never
      // clipped by the bottom edge on short mobile viewports / when its label wraps.
      var visH = Math.min(H, window.innerHeight || H);
      var pad = 10;
      for (var i = 0; i < coData.length; i++) {
        var d = coData[i];
        var left = (prodX / 100) * W + camX * vmin + (d.cx - 50) * vmin * scale;
        var top = cyFrac * H + camY * vmin + (d.cy - 50) * vmin * scale;
        var half = (d.el.offsetHeight || 28) / 2;
        var minTop = half + pad, maxTop = visH - half - pad;
        if (maxTop > minTop) { if (top > maxTop) top = maxTop; else if (top < minTop) top = minTop; }
        if (left < pad) left = pad;
        d.el.style.left = left + 'px';
        d.el.style.top = top + 'px';
      }
    }

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var n = chapters.length;

    // Cache per-chapter camera data (data-attrs)
    var cams = [];
    for (var i = 0; i < n; i++) {
      var c = chapters[i];
      cams.push({
        view: c.getAttribute('data-view') || 'front',
        scale: parseFloat(c.getAttribute('data-scale')) || 3,
        x: parseFloat(c.getAttribute('data-x')) || 0,
        y: parseFloat(c.getAttribute('data-y')) || 0,
        roll: parseFloat(c.getAttribute('data-roll')) || 0
      });
    }

    var state = {
      frame: 0, current: 0, target: 0, activeIdx: -1,
      storyTop: 0, max: 1, running: true
    };

    function measure() {
      root.style.setProperty('--llc2-top', headerOffset() + 'px');
      var rect = story.getBoundingClientRect();
      state.storyTop = rect.top + window.pageYOffset;
      state.max = Math.max(1, story.offsetHeight - sticky.offsetHeight);
    }

    function sceneProgress() {
      return clamp01((window.pageYOffset - state.storyTop) / state.max);
    }

    function applyCamera(p) {
      var pos = p * (n - 1);
      var fi = Math.min(n - 1, Math.floor(pos));
      var ti = Math.min(n - 1, fi + 1);
      var seg = pos - fi;
      var from = cams[fi], to = cams[ti];
      var sameView = from.view === to.view;
      var scale = mix(from.scale, to.scale, seg);
      var cx = mix(from.x, to.x, seg);
      var cy = mix(from.y, to.y, seg);
      var roll = mix(from.roll, to.roll, seg);

      var phase = clamp01((seg - 0.28) / 0.44);
      var energy = (sameView || reduce.matches) ? 0 : Math.sin(Math.PI * phase);
      var orbit = energy * (ti % 2 ? 3.5 : -3.5);           // ≤ ±3.5deg
      var blur = energy * 0.2;                               // subtle transition blur only
      var viewBlend = (sameView || reduce.matches) ? 0 : smooth((seg - 0.38) / 0.24);

      var s = world.style;
      s.setProperty('--camera-x', cx + 'vmin');
      s.setProperty('--camera-y', cy + 'vmin');
      s.setProperty('--camera-scale', scale);
      s.setProperty('--camera-roll', roll + 'deg');
      s.setProperty('--camera-orbit', orbit + 'deg');
      s.setProperty('--motion-blur', blur + 'px');

      for (var k = 0; k < views.length; k++) {
        var v = views[k], view = v.getAttribute('data-view'), op = 0;
        if (sameView) op = (view === from.view) ? 1 : 0;
        else if (view === from.view) op = 1 - viewBlend;
        else if (view === to.view) op = viewBlend;
        v.style.opacity = op;
      }

      positionCallouts(scale, cx, cy);
    }

    function setActive(idx) {
      if (idx === state.activeIdx) return;
      state.activeIdx = idx;
      for (var i = 0; i < n; i++) {
        var on = i === idx;
        chapters[i].classList.toggle('is-active', on);
        chapters[i].setAttribute('aria-hidden', on ? 'false' : 'true');
      }
      for (var j = 0; j < jumps.length; j++) jumps[j].classList.toggle('is-active', j === idx);
      for (var c = 0; c < callouts.length; c++) {
        callouts[c].classList.toggle('is-active', parseInt(callouts[c].getAttribute('data-index'), 10) === idx);
      }
      if (counterNow) counterNow.textContent = pad2(idx + 1);
    }

    function render(p) {
      applyCamera(p);
      if (railFill) railFill.style.width = (p * 100) + '%';
      setActive(Math.min(n - 1, Math.round(p * (n - 1))));
    }

    function tick() {
      var ease = reduce.matches ? 1 : 0.16;
      state.current += (state.target - state.current) * ease;
      render(state.current);
      if (Math.abs(state.current - state.target) > 0.0005) {
        state.frame = requestAnimationFrame(tick);
      } else {
        state.current = state.target;
        render(state.current);
        state.frame = 0;
      }
    }

    function requestRender() {
      state.target = sceneProgress();
      if (!state.frame) state.frame = requestAnimationFrame(tick);
    }

    function onResize() { measure(); requestRender(); }

    function jumpTo(idx) {
      measure();
      var top = state.storyTop + state.max * (idx / (n - 1));
      window.scrollTo({ top: top, behavior: reduce.matches ? 'auto' : 'smooth' });
    }

    // wire jump buttons
    var jumpHandlers = [];
    for (var jb = 0; jb < jumps.length; jb++) {
      (function (btn, idx) {
        var h = function () { jumpTo(idx); };
        btn.addEventListener('click', h);
        jumpHandlers.push([btn, h]);
      })(jumps[jb], parseInt(jumps[jb].getAttribute('data-llc2-jump'), 10) || 0);
    }

    window.addEventListener('scroll', requestRender, { passive: true });
    window.addEventListener('resize', onResize);

    measure();
    requestRender();
    // ensure images are decoded before their chapter can appear
    for (var im = 0; im < views.length; im++) { if (views[im].loading === 'lazy') views[im].loading = 'eager'; }

    root.__llc2 = {
      jumpTo: jumpTo,
      destroy: function () {
        window.removeEventListener('scroll', requestRender);
        window.removeEventListener('resize', onResize);
        for (var q = 0; q < jumpHandlers.length; q++) jumpHandlers[q][0].removeEventListener('click', jumpHandlers[q][1]);
        if (state.frame) cancelAnimationFrame(state.frame);
        state.running = false;
        root.__llc2 = null;
      }
    };
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-llc2-scrolly]').forEach(initScrolly);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-llc2-scrolly]');
    if (root) initScrolly(root);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-llc2-scrolly]');
    if (root && root.__llc2) root.__llc2.destroy();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('[data-llc2-scrolly]');
    if (!root || !root.__llc2) return;
    var chapter = e.target.closest('[data-llc2-chapter]');
    if (chapter) root.__llc2.jumpTo(parseInt(chapter.getAttribute('data-index'), 10) || 0);
  });
})();
